<template>
  <div class="container saldo">
    <nav class="level">
      <b-dropdown>
        <button class="button is-primary" slot="trigger">
          <span>År</span>
          <span v-if="selectedYear !== ''">: {{ selectedYear }}</span>
          <b-icon icon="caret-down"></b-icon>
        </button>

        <b-dropdown-item v-for="(year, index) in years" v-bind:key="index" has-link>
          <a @click="setSelectedYear(year)">{{ year }}</a>
        </b-dropdown-item>
      </b-dropdown>

      <div class="level-right">
        <div class="level-item">
          <a @click="getReportFile" class="button is-info">
            <b-icon icon="save"></b-icon>
            <span>Last ned rapport</span>
          </a>
        </div>

        <div class="level-item" v-if="isAdmin">
          <b-select placeholder="Velg firma" v-model="branch">
            <option
              v-for="option in customers"
              :value="option.id"
              :key="option.id"
            >{{ `${option.name} (${option.id})` }}</option>
          </b-select>
        </div>
      </div>
    </nav>

    <b-table
      :data="data"
      :paginated="true"
      :per-page="perPage"
      :current-page.sync="currentPage"
      :loading="loading"
      :striped="true"
      :narrowed="true"
    >
      <template slot-scope="props">
        <b-table-column field="accountType" label="Konto" sortable>{{ props.row.accounttype }}</b-table-column>

        <b-table-column
          field="accountType"
          label="Måned"
          sortable
        >{{ props.row.reportDateFrom | moment("MMM YYYY") }}</b-table-column>

        <b-table-column
          field="balanceEndOfMonth"
          label="Balanse"
          sortable
        >{{ props.row.balanceEndOfMonth | currency }}</b-table-column>
      </template>
    </b-table>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      perPage: 100,
      currentPage: 1
    };
  },

  methods: {
    ...mapActions("saldo", ["getReportData", "setSelectedYear", "getReportFile"]),
    ...mapActions("customers", ["getCustomers"])
  },

  computed: {
    ...mapGetters("saldo", ["data", "loading", "selectedYear", "years"]),
    ...mapGetters("customers", ["customers"]),
    ...mapGetters("auth", ["isAdmin"]),
    branch: {
      get() {
        return this.$store.state.saldo.branch;
      },
      set(value) {
        this.$store.dispatch("saldo/setBranch", value);
      }
    }
  },

  created() {
    this.getReportData();
    this.getCustomers();
  }
};
</script>

<style lang="scss" scoped>
div.saldo {
  margin-top: 32px;
}
</style>